import { useTranslation } from 'react-i18next'
import { Col, Form, Row } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import MandatoryField from '../../MandatoryField/MandatoryField'
import ModalComponent from '../../Modals/ModalComponent'
import { DeleteIcon } from '../../Icons/DeleteIcon'
import styled from 'styled-components'
import ArraySelect from '../../Select/ArraySelect'
import ZipSuggestion from '../../Forms/ZipSuggestion'
import { getFakeEvent } from '../../../utils/utils'
import { colors } from '../../../styles/colors'

const StyledDeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 44px;
  border: 1px solid ${colors.gray2};
  background-color: white;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 0.5rem;
  padding: 0;

  &:hover {
    background-color: ${colors.gray1};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

const Address = ({
  address,
  officeName,
  handleChangeAddress,
  handleDeleteAddress,
  availableCountries,
  formErrors,
  resetFormErrorsByKey,
  isDeletable,
  addressType,
  backendMessageMap,
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const { t } = useTranslation()
  const [_address, _setAddress] = useState(address)

  const handleLocalChange = (e) => {
    const { name, value } = e.target
    _setAddress((prev) => ({ ...prev, [name]: value }))
    // resetFormErrorsByKey(name)
    resetFormErrorsByKey(`${addressType}.${name}`)
  }

  const handleLocalChangeCheckbox = (e) => {
    const value = e.target.checked
    const { name } = e.target
    _setAddress((prev) => ({ ...prev, [name]: value }))
    // resetFormErrorsByKey(name)
    resetFormErrorsByKey(`${addressType}.${name}`)
  }
  // helper to get full error key from backend pointer errors
  const getError = (field) => {
    const raw = formErrors?.[`${addressType}.${field}`]
    return backendMessageMap?.[raw] || raw || null
  }

  useEffect(() => {
    if (JSON.stringify(address) !== JSON.stringify(_address)) {
      handleChangeAddress(_address)
    }
  }, [_address, address, handleChangeAddress])

  if (_address == null) {
    return null
  }

  return (
    <>
      <Row className='align-items-baseline'>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:company')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('EmployeeFormAddress:company')}
              name='secondaryOfficeName'
              value={officeName || ''}
              disabled
              isInvalid={!!getError('secondaryOfficeName')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('secondaryOfficeName')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('formularFields:secondaryName')}</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={t('EmployeeFormAddress:company')}
                  name='secondaryOfficeName'
                  onChange={handleLocalChange}
                  value={_address.secondaryOfficeName || ''}
                  isInvalid={!!getError('secondaryOfficeName')}
                />
                <Form.Control.Feedback type='invalid'>
                  {getError('secondaryOfficeName')}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className='mb-3'>
                <Form.Check
                  name='useSecondaryOfficeName'
                  type='checkbox'
                  checked={_address.useSecondaryOfficeName || false}
                  onChange={handleLocalChangeCheckbox}
                  label={t('assetPage:replaceOfficeName')}
                  id={`useSecondaryOfficeName`}
                />
                {getError('useSecondaryOfficeName') && ( // UPDATED
                  <StyledValidationMessage>
                    {getError('useSecondaryOfficeName')}
                  </StyledValidationMessage>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
      {/*<Row>
        <Col sm="6" lg="3">
          <Form.Group className="mb-3">
            <Form.Label>{t('OfficeAddress:addressNumber')}</Form.Label>
            <Form.Control
              placeholder={t('OfficeAddress:addressNumber')}
              value={_address.addressnumber}
              onChange={handleLocalChange}
              name="addressnumber"
              isInvalid={formErrors && formErrors.addressnumber}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors && formErrors.addressnumber}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>*/}
      <Row>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:street')}*</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('EmployeeFormAddress:street')}
              name='street'
              onChange={handleLocalChange}
              value={_address.street || ''}
              isInvalid={!!getError('street')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('street')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:houseNumber')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('EmployeeFormAddress:houseNumber')}
              name='streetNr'
              onChange={handleLocalChange}
              value={_address.streetNr || ''}
              isInvalid={!!getError('streetNr')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('streetNr')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('formularFields:co')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('formularFields:co')}
              name='careOf'
              onChange={handleLocalChange}
              value={_address.careOf || ''}
              isInvalid={!!getError('careOf')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('careOf')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:mailbox')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('EmployeeFormAddress:mailbox')}
              name='postOfficeBox'
              onChange={handleLocalChange}
              value={_address.postOfficeBox || ''}
              isInvalid={!!getError('postOfficeBox')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('postOfficeBox')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:postcode')}*</Form.Label>
            <ZipSuggestion
              type='text'
              placeholder={t('EmployeeFormAddress:postcode')}
              name='zipCode'
              onChange={handleLocalChange}
              value={_address.zipCode || ''}
              isInvalid={!!getError('zipCode')}
              onChangeSuggestion={(obj) =>
                handleLocalChange(getFakeEvent('city', obj.cityName, 'text'))
              }
              countryIsoCode={_address.countryIsoCode || 'de'}
            >
              <Form.Control.Feedback type='invalid'>
                {getError('zipCode')}
              </Form.Control.Feedback>
            </ZipSuggestion>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:city')}*</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('EmployeeFormAddress:city')}
              name='city'
              onChange={handleLocalChange}
              value={_address.city || ''}
              isInvalid={!!getError('city')}
            />
            <Form.Control.Feedback type='invalid'>
              {getError('city')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm='6' lg='3'>
          <Form.Group className='mb-3'>
            <Form.Label>{t('EmployeeFormAddress:country')}</Form.Label>
            <ArraySelect
              name='countryIsoCode'
              onChange={handleLocalChange}
              value={_address.countryIsoCode || ''}
              options={availableCountries}
              otherValueKey={'isoCode'}
              returnEvent
              isInvalid={!!getError('countryIsoCode')}
            />

            <Form.Control.Feedback type='invalid'>
              {getError('countryIsoCode')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <div className='d-flex justify-content-end'>
        {isDeletable && (
          <StyledDeleteButton
            onClick={() => setOpenDeleteModal(true)}
            title={t('deleteButton')}
          >
            <DeleteIcon />
          </StyledDeleteButton>
        )}
      </div>
      <MandatoryField />
      <hr />
      {openDeleteModal && (
        <ModalComponent
          ModalTitle={t('OfficeAddress:deleteAddress')}
          functionButton1={() => {
            handleDeleteAddress(_address.id)
          }}
          BodyPart1={t('OfficeAddress:areYouSure')}
          textButton1={t('delete')}
          variantButton1='danger'
          variantBody='alert-danger'
          functionCancel={() => {
            setOpenDeleteModal(false)
          }}
        />
      )}
    </>
  )
}

export default Address
